/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsseriespeoplejoined3Inputs */

const en_statsseriespeoplejoined3 = /** @type {(inputs: Statsseriespeoplejoined3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People joined`)
};

const de_statsseriespeoplejoined3 = /** @type {(inputs: Statsseriespeoplejoined3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beigetretene Personen`)
};

/**
* | output |
* | --- |
* | "People joined" |
*
* @param {Statsseriespeoplejoined3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsseriespeoplejoined3 = /** @type {((inputs?: Statsseriespeoplejoined3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsseriespeoplejoined3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsseriespeoplejoined3(inputs)
	return de_statsseriespeoplejoined3(inputs)
});
export { statsseriespeoplejoined3 as "statsSeriesPeopleJoined" }